import React from "react";
import { Box, Divider } from "@mui/material";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../types";
import { isFieldVisible } from "./config/additionalInfoConfig";
import ToolsSection from "./sections/ToolsSection";
import CertificatesSection from "./sections/CertificatesSection";
import ComplexitySection from "./sections/ComplexitySection";
import ScoreSection from "./sections/ScoreSection";
import CreditsSection from "./sections/CreditsSection";
import ReportingTagsSection from "./sections/ReportingTagsSection";

const SectionDivider: React.FC = () => <Divider sx={{ opacity: 0.6 }} />;

const AdditionalInfoStep: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  if (!data.type) return null;

  const showComplexity = isFieldVisible(
    "complexity",
    data.type,
    data.is_standalone,
  );
  const showCertificatesGroup =
    isFieldVisible("certificate_ids", data.type, data.is_standalone) ||
    isFieldVisible("badge_id", data.type, data.is_standalone) ||
    true;
  const showCredits = isFieldVisible("credits", data.type, data.is_standalone);
  const showReportingTags = isFieldVisible(
    "lo_tag",
    data.type,
    data.is_standalone,
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <ToolsSection data={data} setData={setData} errors={errors} />

      {showCertificatesGroup && (
        <>
          <SectionDivider />
          <CertificatesSection data={data} setData={setData} errors={errors} />
        </>
      )}

      {showComplexity && (
        <>
          <SectionDivider />
          <ComplexitySection data={data} setData={setData} errors={errors} />
        </>
      )}

      <SectionDivider />
      <ScoreSection data={data} setData={setData} errors={errors} />

      {showCredits && (
        <>
          <SectionDivider />
          <CreditsSection data={data} setData={setData} errors={errors} />
        </>
      )}

      {showReportingTags && (
        <>
          <SectionDivider />
          <ReportingTagsSection data={data} setData={setData} errors={errors} />
        </>
      )}
    </Box>
  );
};

export default AdditionalInfoStep;
